module.exports = __webpack_public_path__ + "static/media/success.6143c160.mp3";